import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import {Subject} from 'rxjs';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import {MatCalendar, MatDatepickerInputEvent } from '@angular/material/datepicker';
import {default as _rollupMoment} from 'moment';
import { IDatepickerOption } from '../../../models/IDatepickerOption';
import { FormControl } from '@angular/forms';



//Formats from moment.js
export const MY_FORMATS_KEY_HOR = {
  parse: {
    dateInput: 'MM/DD/YYYY',
  },
  display: {
    dateInput: 'MM/DD/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
    
  },
};


@Component({
  selector: 'ff-datepicker-horizontal',
  templateUrl: './datepicker-horizontal.component.html',
  encapsulation: ViewEncapsulation.Emulated,
  styleUrls: ['./datepicker-horizontal.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS_KEY_HOR},
  ],
})
export class DatepickerHorizontalComponent implements OnInit {

  ffDatepickerHeaderHorizontal = FFDatepickerHeaderHorizontal;

    /**
     * Options to configure min and max date to datepicker
     * Use the IDatepickerOption interface: { minDate: Date, maxDate: Date }
     * * @internal
    */
     @Input() options?: IDatepickerOption;

     /**
     * Options to enable ordisable the datepicker
     * * @internal
    */
    @Input() isDisabled?: boolean;

     /**
      * Return the selection updated each time the user choses a new date.
      * * @internal
     */
    @Output() selection = new EventEmitter<Date> ();
  

    //variable date that will be used as the output
    date: Date;

 
    minDate : Date = new Date(0);
    maxDate : Date = new Date();

    isDpActive = false;
    isDateSelected = false;


    formDate = new FormControl();
  
  

  constructor(
  ) { }

  ngOnInit() {
    if (this.options !== undefined){
      this.minDate = this.options.minDate !== undefined ? this.options.minDate : this.minDate;

      //If there is no input with maxDate parameter, maxDate will be 30 years from the present date
      if (this.options.maxDate !== undefined){
        this.maxDate = this.options.maxDate
      } else {
        this.maxDate.setFullYear(this.maxDate.getFullYear() + 30);
      }
    } else {
      this.maxDate.setFullYear(this.maxDate.getFullYear() + 30);
    }

    this.isDisabled = this.isDisabled !== undefined ? this.isDisabled : false;

  }

  ngOnChanges() {
    if (this.isDisabled){
      this.formDate.disable();
    } else {
      this.formDate.enable();
    }
  }



  //Handles date selection
  chosenDateHandler(event: MatDatepickerInputEvent<Date>) {
    this.date = event.value;

    this.isDateSelected = this.date !== null ? true : false;

    this.selection.emit(this.date);

  }

   //Toggle control for calendar
   onCalendarActive() { 
    this.isDpActive = !this.isDpActive;
  }
}



/** Custom header component for datepicker. */
@Component({
  selector: 'ff-datepicker-header-horizontal',
  styles: [`
    .dp-header {
      padding: 0.5em;
      background-color: #c81414;
      color: white;
      height: 4em;
      border-radius: 4px;
      width: 150px;
      height: 338px;
    }

    .year-header-label {
      font-weight: 100;
      text-align: center;
      padding: 14px;
      opacity: 0.7;
      font-size: 20px;
    }

    .dp-year {
      margin-bottom: -9px;
      margin-top: 3px;
      padding: 10px;
    }

    .year-header-label {
      font-weight: 100;
      text-align: center;
      padding: 14px;
      opacity: 0.7;
      font-size: 20px;
    }

    .dp-day {
      padding-left: 25px;
    }

    .day-header-label {
      font-size: 22px;
    }

    .dp-date {
      padding-left: 25px;
      margin-top: -10px;
    }

    .date-header-label {
      font-size: 22px;
    }

    .month-header-label {
      font-weight: 400;
      text-align: center;
      padding: 14px;
      font-size: 1.2em;
    }

    .selector-container {
      justify-content: space-between;
      background-color: #c81414;
      border-radius: 5px;
    }

    .button-container {
      position: absolute;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 59%;
      background-color: white;
      padding: 15px 5px 15px;
      right: 0px;
      top: 0px;
      margin-top: 9px;
    }

    .btn-selector-left {
      background-color: transparent;
      color: black;
      width: 10%;
      border-style: none;
      display: flex;
      margin-left: -13%;
    }

    .btn-selector-double-arrow-left {
      background-color: transparent;
      color: black;
      width: 10%;
      border-style: none;
      display: flex;
      margin-top: 12px;
      margin-left: 2px;
    }

    .btn-selector-right {
      background-color: transparent;
      color: black;
      width: 10%;
      border-style: none;
      display: flex;
      margin-right: -3%;
    }

    .btn-selector-double-arrow-right {
      background-color: transparent;
      color: black;
      width: 10%;
      border-style: none;
      display: flex;
      margin-top: 12px;
    }

    .btn-selector-double-arrow-right .mat-icon {
      margin: -77%;
      width: 18px;
    }

    .btn-selector-double-arrow-left .mat-icon {
      margin: -77%;
      width: 18px;
    }

    .label-header {
      margin-top: 4px;
      font-size: 18px;
      margin-left: 9px;
    }

    .btn-selector-right:hover, .btn-selector-left:hover, .btn-selector-double-arrow-left:hover, .btn-selector-double-arrow-right:hover {
      transform:scale(1.3,1.3);
    }
   
  `],
  templateUrl: '../headers/datepicker-horizontal-header.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FFDatepickerHeaderHorizontal<D> implements OnDestroy {
  private _destroyed = new Subject<void>();

  constructor(
      private _calendar: MatCalendar<D>, private _dateAdapter: DateAdapter<D>) {
  }

  ngOnDestroy() {
    this._destroyed.next();
    this._destroyed.complete();
  }

  //Gets year label to use it in the header
  get yearLabel() {
    return this._dateAdapter
        .format(this._calendar.activeDate, 'YYYY');
  }

  //Gets month label to use it in the header
  get monthLabel() {
    return this._dateAdapter
        .format(this._calendar.activeDate, "MMMM");
  }

  get dateLabel() {
    return this._dateAdapter
        .format(this._calendar.activeDate, "MMM D");
  }

  //Gets month label to use it in the header
  get dayLabel() {
    return this._dateAdapter
        .format(this._calendar.activeDate, "ddd");
  }
  

  previousClicked(mode: 'month' | 'year') {
    this._calendar.activeDate = mode === 'month' ?
        this._dateAdapter.addCalendarMonths(this._calendar.activeDate, -1) :
        this._dateAdapter.addCalendarYears(this._calendar.activeDate, -1);
  }

  nextClicked(mode: 'month' | 'year') {
    this._calendar.activeDate = mode === 'month' ?
        this._dateAdapter.addCalendarMonths(this._calendar.activeDate, 1) :
        this._dateAdapter.addCalendarYears(this._calendar.activeDate, 1);
  }


} 


